/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Signals_Geo_CaptionInputs */

const en_directory_detail_signals_geo_caption = /** @type {(inputs: Directory_Detail_Signals_Geo_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How ready this page is to be cited by AI search engines`)
};

const zh_directory_detail_signals_geo_caption = /** @type {(inputs: Directory_Detail_Signals_Geo_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本页面被 AI 搜索引擎引用的就绪程度`)
};

/**
* | output |
* | --- |
* | "How ready this page is to be cited by AI search engines" |
*
* @param {Directory_Detail_Signals_Geo_CaptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_signals_geo_caption = /** @type {((inputs?: Directory_Detail_Signals_Geo_CaptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Signals_Geo_CaptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_signals_geo_caption(inputs)
	return zh_directory_detail_signals_geo_caption(inputs)
});
export { directory_detail_signals_geo_caption as "directory.detail.signals.geo_caption" }